(function() {
    'use strict';
    angular.module('app')
        .controller('ManifestsViewController', function ($scope, $location, $routeParams, $timeout, ManifestService,
                                                         toastr, ConfirmationModalFactory, ClientService, $filter,
                                                         Carrier, Location, ViewChangeNotificationFactory) {
            /* todo: put all frequency in an array*/
            var vm = this;

            vm.companyList            = [];
            vm.offices                = [];
            vm.getOfficeLocation      = getOfficeLocation;
            vm.onSelectOfficeLocation = onSelectOfficeLocation;
            vm.addingTimeSlot         = false;
            vm.addTimeSlot            = addTimeSlot;
            vm.saveTimeSlot           = saveTimeSlot;
            vm.cancelTimeSlot         = cancelTimeSlot;
            vm.formSlot               = {};
            vm.timeOptions            = [];
            vm.timeAmPm               = [
                {name: 'AM'},
                {name: 'PM'}
            ];
            vm.weekDays = [
                { short: 'Mon', long: 'Monday', status: false },
                { short: 'Tue', long: 'Tuesday', status: false },
                { short: 'Wed', long: 'Wednesday', status: false },
                { short: 'Thu', long: 'Thursday', status: false },
                { short: 'Fri', long: 'Friday', status: false },
                { short: 'Sat', long: 'Saturday', status: false },
                { short: 'Sun', long: 'Sunday', status: false },
            ];

            
            $scope.viewMode = {};
            $scope.getCompanies = getCompanies;
            $scope.searchCarrierProfile = searchCarrierProfile;
            $scope.searchServiceProfile = searchServiceProfile;
            $scope.disableMode = false;
            
            $scope.form = {
                company: ''
            };
            var viewConfirmation = new ConfirmationModalFactory({},{
                message: $filter('translate')('messages.warning.viewChange.MESSAGE'),
                code: $filter('translate')('messages.warning.viewChange.CODE'),
                buttonLabel: {
                    true: $filter('translate')('labels.button.YES'),
                    false: $filter('translate')('labels.button.NO')
                }
            });
            
            
            $scope.form.subAccountList = [
                {name: 'Sub Account 1'},
                {name: 'Sub Account 2'},
                {name: 'Sub Account 3'}
            ];

            $scope.form.pickupList = [
                {name: 'Pickup 1'},
                {name: 'Pickup 2'},
                {name: 'Pickup 3'}
            ];
            // Time Slot
            $scope.timeMask = 'tc:ms';
            $scope.timeMaskOptions = {
                maskDefinitions: {
                    '9': /\d/, 'A': /[a-zA-Z]/, '*': /[a-zA-Z0-9]/, 't': /[0-2]/, 'c': /[0-9]/, 'm': /[0-5]/, 's': /[0-9]/
                }
            };
            
            vm.timeSlots = [
                {
                    name: 'Time Slot A', 
                    time: '10:00 AM', 
                    frequency: {
                        mon: true,
                        tue: false,
                        wed: true,
                        thu: false,
                        fri: true,
                        sat: false,
                        sun: false
                    },
                    new: false
                },
                {
                    name: 'Time Slot B', 
                    time: '11:50 AM', 
                    frequency: {
                        mon: false,
                        tue: false,
                        wed: true,
                        thu: false,
                        fri: true,
                        sat: false,
                        sun: true
                    },
                    new: false
                },
                {
                    name: 'Time Slot C', 
                    time: '8:00 PM', 
                    frequency: {
                        mon: true,
                        tue: true,
                        wed: true,
                        thu: false,
                        fri: false,
                        sat: false,
                        sun: false
                    },
                    new: false
                }
            ];

            if($routeParams.manifestId){
                $timeout(function (){
                    $scope.manifestId = $routeParams.manifestId;
                    $scope.viewMode.isRead = true;
                });
            }
            $scope.changeView = function () {
                if(!$scope.viewMode.isRead){
                    $timeout(function(){
                        if(!angular.equals($scope.form, $scope.formRaw)){
                            $('.toast').remove();
                            $scope.viewMode.isRead = false;
                            viewConfirmation.getInstance().result.then(function(cond){
                                if(cond){
                                    $scope.viewMode.isRead = true;
                                    $scope.form = angular.copy($scope.formRaw);
                                    $scope.manifestForm.$setUntouched();
                                }
                            });
                        }else{ 
                            $scope.manifestForm.$setUntouched();
                        }
                    });
                }
                else if($scope.viewMode.isRead){
                    ViewChangeNotificationFactory.showNofication($scope.viewMode.isRead);
                    $scope.viewMode.isRead = !$scope.viewMode.isRead;
                }
            };
            
            function addTimeSlot(){  
                vm.addingTimeSlot = true;
                vm.formSlot.frequency = angular.copy(vm.weekDays);
            }
            
            function saveTimeSlot(){  
                var newTimeSlot = {
                    name: vm.formSlot.name,
                    time: vm.formSlot.time.name + ' ' + vm.formSlot.timeAmPm.name,
                    frequency: {}
                };

                angular.forEach(vm.formSlot.frequency, function(i, key){
                    newTimeSlot.frequency[i.short.toLowerCase()] = i.status;
                });

                vm.timeSlots.push(newTimeSlot);
                toastr.success('Saved', 'saved!')

                resetFormSlot();
            }
            
            function cancelTimeSlot(){  
                resetFormSlot();
            }

            function resetFormSlot(){
                vm.formSlot = {};
                vm.addingTimeSlot = false;
            }

            $scope.form.cancelAddingTimeSlot = function() {
                $scope.form.timeSlots.pop();
            };

            // function to submit the form after all validation has occurred
            $scope.submitForm = function(form) {

                if(!form.$valid){
                    //do something
                }
                if (form.$valid) {
                    ManifestService.postScheduledPickUps(function(data){
                        toastr.success('Saved', 'saved!')
                    },function(err){
                        toastr.warning('Cannot be saved', 'Please contact the administrator');
                        console.log(err);
                    });
                };
            };

            $scope.return = function () {
            if(!angular.equals($scope.form, $scope.formRaw)){
                viewConfirmation.getInstance().result.then(function(cond){
                    if(cond){
                        $location.path('/manifests').search({tab: 'scheduledPickUps'});
                    }
                });
            }
            }
            $scope.formRaw = angular.copy($scope.form);

            function getCompanies (search) {
                var data = {};
                if(search)
                    data.name = search;
                ClientService.Company.getAll(success,error,data);

                function success(data) {
                    $scope.form.companyList = data.content;
                };
                function error(error) {
                    console.log(error);
                };
            }

            function searchCarrierProfile(select) {
                if(!select.open){
                    return false;
                }
                $scope.isSearching = true;
                $scope.carrierProfiles = [];
                Carrier.getExternalCarrierProfiles(data=>{
                    $scope.carrierProfiles = data.content;
                    $scope.isSearching = false;
                }, err=>{
                    toastr.eror('Unable to get carrier profiles', err.message);
                    $scope.isSearching = false;
                }, {
                    name: select.search
                })
            }

            function searchServiceProfile(select, carrierProfile) {
                if(!select.open){
                    return false;
                }
                $scope.isSearching = true;
                $scope.serviceProfiles = [];
                Carrier.getServiceProfiles(data=>{
                    $scope.serviceProfiles = data.content;
                    $scope.isSearching = false;
                }, err=>{
                    toastr.eror('Unable to get carrier profiles', err.message);
                    $scope.isSearching = false;
                }, {
                    name: select.search,
                    carrierProfileId: carrierProfile.id
                })
            }
            init();

            function init(){
                getCompanyList();
                initTimeOptions();
            }

            function getCompanyList(){
                ClientService.Company.getAll(function(data) {
                    vm.companyList = data.content;
                }, function(err) {
                    vm.companyList = [];
                    toastr.error('Unable to get companies');
                    console.log(err);
                });
            }

            function initTimeOptions(){
                var newTime = {},
                    hr,
                    min;

                for(var i=1; i<=12; i++){
                    hr = i;
                    
                    for(var j=0; j<=11; j++){
                        min = j * 5;

                        newTime = {
                            hour: hr,
                            minute: min,
                            name: hr + ':' + String('0'+min).slice(-2)
                        };
                        
                        vm.timeOptions.push(newTime);
                    }

                }
            }

            function getOfficeLocation(company){
                ClientService.Location.getByCompany({'company.id': company.id}, function (data) {
                    vm.offices = data.content;
                });
            }

            function onSelectOfficeLocation(data){
                $scope.form.firstName    = data.firstName ? data.firstName : 'N/A';
                $scope.form.lastName     = data.lastName ? data.lastName : 'N/A';
                $scope.form.addressLine1 = data.addressLine1 ? data.addressLine1 : 'N/A';
                $scope.form.addressLine2 = data.addressLine2 ? data.addressLine2 : 'N/A';
                $scope.form.country      = data.location.country.name ? data.location.country.name : 'N/A';
                $scope.form.postCode     = data.location.code ? data.location.code : 'N/A';
                $scope.form.suburb       = data.location.suburb ? data.location.suburb : 'N/A';
                $scope.form.state        = data.location.state ? data.location.state : 'N/A';
                $scope.form.phone        = data.phone1 ? data.phone1 : 'N/A';
                $scope.form.email        = data.email ? data.email : 'N/A';
            }

        });
})();


// WEBPACK FOOTER //
// ./js/controllers/manifests/ManifestsViewController.js